"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const getDayNumber = (date) => (0, date_fns_1.getDayOfYear)(!!date ? new Date(date) : new Date());
exports.default = getDayNumber;
//# sourceMappingURL=getDayNumber.js.map